import React from "react";

export const Error400 = (props: {}) => {
  return <article><main>
    <h1>不正なリクエストです</h1>
  </main></article>
};
